import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'components.MemoryCreateModal.title',
    defaultMessage: 'Create memory',
  },
})
